import { defineComponent as W, useSlots as b, inject as T, computed as p, toValue as E, ref as f, watch as B, createBlock as F, openBlock as _, Teleport as $, createVNode as z, withDirectives as I, cloneVNode as M } from "vue";
import { autoPlacement as N, flip as U, size as V, offset as D } from "../node_modules/.pnpm/@floating-ui_core@1.6.9/node_modules/@floating-ui/core/dist/floating-ui.core.js";
import { useFloatingUI as P } from "../use/floating.js";
const S = Symbol("FloatingElementTeleportKey"), H = /* @__PURE__ */ W({
  name: "PfFloatingUi",
  inheritAttrs: !1,
  __name: "FloatingUi",
  props: {
    reference: {},
    disable: { type: Boolean },
    placement: { default: "bottom" },
    flip: { type: Boolean },
    zIndex: { default: 9999 },
    middleware: { default: () => [] },
    strategy: {},
    offset: {},
    hidden: { type: Boolean },
    animationDuration: { default: 0 },
    width: { default: "auto" },
    minWidth: { default: "trigger" },
    maxWidth: { default: "auto" },
    teleportTo: { default: "body" }
  },
  emits: ["hidden", "shown"],
  setup(h, { emit: v }) {
    const e = h, m = v, i = b(), y = T(S, void 0), u = p(() => e.teleportTo ?? E(y)), r = f(e.hidden), o = f(e.hidden ? 0 : 1), c = f(!1);
    B(() => e.hidden, (t) => {
      t ? (o.value = 0, c.value || (r.value = !0)) : r.value ? r.value = !1 : o.value = 1;
    });
    const g = p(() => {
      const t = typeof e.reference == "string" ? document.querySelector(e.reference) : e.reference;
      return typeof (t == null ? void 0 : t.getBoundingClientRect) < "u" ? t : void 0;
    }), a = f(null), x = p(() => {
      const t = [...e.middleware], s = e.placement === "auto" ? void 0 : e.placement;
      return e.placement === "auto" ? t.push(N()) : e.flip && t.push(U()), (e.width !== "auto" || e.minWidth !== "auto" || e.maxWidth !== "auto") && t.push(V({
        apply({ rects: l }) {
          a.value && (e.width !== "auto" && (a.value.style.width = e.width === "trigger" ? `${l.reference.width}px` : e.width), e.minWidth !== "auto" && (a.value.style.minWidth = e.minWidth === "trigger" ? `${l.reference.width}px` : e.minWidth), e.maxWidth !== "auto" && (a.value.style.maxWidth = e.maxWidth === "trigger" ? `${l.reference.width}px` : e.maxWidth));
        }
      })), e.offset && t.push(D(e.offset)), {
        strategy: e.strategy,
        placement: s,
        middleware: t
      };
    }), d = P(g, a, x);
    function w() {
      var l;
      if (e.disable)
        return () => {
          var n;
          return (n = i.default) == null ? void 0 : n.call(i, d);
        };
      if (r.value)
        return;
      const t = (l = i.default) == null ? void 0 : l.call(i, d);
      if (!(t != null && t.length))
        return;
      t.length > 1 && console.error("FloatingUi should only contain a single child or none");
      const s = (n) => {
        a.value = n instanceof HTMLElement ? n : null, o.value = 1;
      };
      return I(M(t[0], {
        style: {
          position: d.strategy,
          top: 0,
          left: 0,
          opacity: o.value,
          transform: `translate3d(${Math.round(d.x)}px,${Math.round(d.y)}px,0)`,
          transition: `opacity ${e.animationDuration}ms cubic-bezier(.54, 1.5, .38, 1.11)`,
          zIndex: e.zIndex
        },
        onTransitionstart: (n) => {
          n.propertyName === "opacity" && o.value > 0 && (c.value = !0);
        },
        onTransitionend: (n) => {
          n.propertyName === "opacity" && (o.value ? m("shown") : (r.value = !0, c.value = !1, m("hidden")));
        }
      }), [
        [{ mounted: s }]
      ]);
    }
    return (t, s) => (_(), F($, {
      to: u.value === "inline" ? void 0 : u.value,
      disabled: !u.value || u.value === "inline"
    }, [
      z(w)
    ], 8, ["to", "disabled"]));
  }
});
export {
  S as FloatingElementTeleportKey,
  H as default
};
